/**
 * Atmosphere · la capa de canvas del sistema.
 *
 * El fondo de la aplicación no es un color plano: es un degradado diagonal de
 * `--bg-0` a `--bg-1` con dos manchas de luz encima —una de marca arriba a la
 * derecha, una fría abajo a la izquierda—. Todo sale de tokens, así que cambiar
 * la paleta lo cambia entero (ver `docs/design/dark-v5-paletas.md`).
 *
 * Se monta `fixed inset-0` debajo del shell (z-index 0); el shell va con
 * `position: relative; z-index: 1` para quedar arriba. El degradado NO usa
 * `background-attachment: fixed` —roto en Safari de iOS—: por eso es una capa
 * propia y no el fondo del `<body>`, que conserva `--background` plano de
 * respaldo.
 *
 * El GRANO no vive acá sino en `body::after`, aunque conceptualmente sea parte
 * del canvas: esta capa declara `z-index: 0` y con eso abre un contexto de
 * apilado del que nada puede salir, mientras que el grano tiene que quedar por
 * encima de los diálogos —que Radix monta por portal colgando de `<body>`—.
 * El detalle está comentado en la regla de `src/index.css`.
 *
 * Se monta una sola vez, en `AppLayout`.
 */
export function Atmosphere() {
  return <div className="atmosphere" aria-hidden />;
}
